export default {
  license: process.env.REACT_APP_MUI_LICENSE || ''
}
